import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../public/img/logo-white.svg'


const _hoisted_1 = { class: "[overflow-anchor:none] bg-gray-800 text-gray-100 px-3 sm:px-5" }
const _hoisted_2 = { class: "flex flex-wrap justify-between gap-5 max-w-6xl mx-auto px-6 py-8 sm:py-14" }
const _hoisted_3 = { class: "flex-1 min-w-full mt-1.5 w-50 shrink-0 sm:min-w-0" }
const _hoisted_4 = { class: "block mt-1 mb-3 text-muted" }
const _hoisted_5 = { class: "list-unstyled text-small text-gray-400" }
const _hoisted_6 = { class: "flex-1 w-50 min-w-fit shrink-0" }
const _hoisted_7 = { class: "list-unstyled text-small text-gray-400" }
const _hoisted_8 = { class: "flex-1 w-50 min-w-fit shrink-0" }
const _hoisted_9 = { class: "text-lg font-bold" }
const _hoisted_10 = { class: "list-unstyled text-small text-gray-400" }
const _hoisted_11 = { class: "flex-1 w-50 min-w-fit shrink-0" }
const _hoisted_12 = { class: "text-lg font-bold" }
const _hoisted_13 = { class: "list-unstyled text-small text-gray-400" }

import { ref } from 'vue';
import { insertConsentLinks } from '@/common/consent';


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const year = ref(new Date().getFullYear());

insertConsentLinks();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              class: "text-gray-100 fill-current",
              alt: "NsLookup logo",
              width: "106",
              height: "18"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, "© " + _toDisplayString(year.value), 1),
            _cache[1] || (_cache[1] = _createStaticVNode("<li class=\"social-icons\"><a class=\"mr-3\" href=\"https://twitter.com/nslookupio\" target=\"_blank\" rel=\"noopener noreferrer\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-twitter inline\" viewBox=\"0 0 16 16\"><path d=\"M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z\"></path></svg></a><a class=\"text-muted\" href=\"https://www.linkedin.com/company/nslookupio/\" target=\"_blank\" rel=\"noopener noreferrer\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-linkedin inline\" viewBox=\"0 0 16 16\"><path d=\"M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z\"></path></svg></a></li>", 1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "text-lg font-bold" }, "DNS tools", -1)),
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/reverse-ip-lookup/"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Reverse IP lookup", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/dns-checker/"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("DNS checker", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/website-to-ip-lookup/"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Website to IP lookup", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/cname-lookup/"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("CNAME lookup", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/txt-lookup/"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("TXT lookup", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h5", _hoisted_9, [
          _createVNode(_component_router_link, { to: "/learning/" }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Learning center", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/learning/dns-record-types/"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("DNS record types", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/install/"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Browser extension", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h5", _hoisted_12, [
          _createVNode(_component_router_link, { to: "/about/" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("About", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("ul", _hoisted_13, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/contact-us/"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("Contact", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/sponsor/"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("Advertise", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/privacy-policy/"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Privacy policy", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "text-muted",
              to: "/terms-and-conditions/"
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("Terms and conditions", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "text-muted",
              href: "https://status.nslookup.io",
              rel: "nofollow noopener noreferrer",
              target: "_blank"
            }, "Status")
          ], -1)),
          _cache[17] || (_cache[17] = _createElementVNode("li", null, [
            _createElementVNode("span", { "data-ccpa-link": "1" })
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})